import { useRouter } from 'next/router'

import SeriesQ from '@/queries/SeriesQ'
import UserQ from '@/queries/UserQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'
import {
  getSATBootcampUrl,
  getSeriesUrl,
  getSignUpUrl,
  SERIES_REFERRAL_USER_QUERY_PARAM,
} from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

export default function SeriesReferredBanner({ series }: { series: Query }): JSX.Element | null {
  const currentUser = useUser()
  const router = useRouter()
  const query = useQuery()

  const maybeReferrerUserId = router.query[SERIES_REFERRAL_USER_QUERY_PARAM]
  const referrerUserId =
    maybeReferrerUserId == null ? null : Number.parseInt(`${maybeReferrerUserId}`, 10) || null

  const seriesId = series(SeriesQ.id) ?? 0
  const isSATBootcamp = series(SeriesQ.isSATSeries()) ?? false
  const referrerUser =
    referrerUserId == null ? null : query.one(UserQ.where({ id: referrerUserId }))

  const referrerUserName = referrerUser?.(UserQ.first_name)
  const isRegisteredOrSelfReserved = currentUser.isLoggedOut
    ? false
    : (series(SeriesQ.isUserRegisteredOrSelfReserved(currentUser.id)) ?? false)

  const isFriendReserved = series(SeriesQ.isReservedByFriend(currentUser.id)) ?? false

  if (!isSATBootcamp) {
    return null
  }

  if (isFriendReserved && !isRegisteredOrSelfReserved) {
    return (
      <Alert variant="info-blue" my="16px">
        Your friend invited you to join their SAT Bootcamp! Click{' '}
        <ShwLink href={getSATBootcampUrl()} isExternal>
          here
        </ShwLink>{' '}
        to learn more about the program.
      </Alert>
    )
  }

  if (referrerUserName == null || isRegisteredOrSelfReserved) {
    return null
  }

  return currentUser.isLoggedOut ? (
    <Alert variant="info-blue" my="16px">
      Your friend {referrerUserName} has invited you to join their SAT Bootcamp! Click{' '}
      <ShwLink href={getSATBootcampUrl()} isExternal>
        here
      </ShwLink>{' '}
      to learn more about the program, or{' '}
      <ShwLink href={getSignUpUrl(getSeriesUrl(seriesId), currentUser)}>create an account</ShwLink>{' '}
      to get started.
    </Alert>
  ) : (
    <Alert variant="info-blue" my="16px">
      Your friend {referrerUserName} has invited you to join their SAT Bootcamp! Click{' '}
      <ShwLink href={getSATBootcampUrl()} isExternal>
        here
      </ShwLink>{' '}
      to learn more about the program.
    </Alert>
  )
}
